module.exports = __webpack_public_path__ + "static/media/icon-gift.ca6aa7f7.svg";